import { render, staticRenderFns } from "./CaseLedger.vue?vue&type=template&id=4f4b48f5&scoped=true"
import script from "./CaseLedger.vue?vue&type=script&lang=js"
export * from "./CaseLedger.vue?vue&type=script&lang=js"
import style0 from "./CaseLedger.vue?vue&type=style&index=0&id=4f4b48f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4b48f5",
  null
  
)

export default component.exports